// import React from 'react';
// import { Link } from 'react-router';
// import { addCartItem } from '../redux/productSlice';
// import { useDispatch } from 'react-redux';


// function CardFeature({image, name, category, price,loading,id }){ 
//     const dispatch= useDispatch();
//     const handleAddCartProduct= (e)=>{
//     // e.stopPropagation();
//     dispatch(addCartItem({
//         _id:id,
//         name:name,
//         price:price,
//         category:category,
//         image:image,
//     }))


//   };

//     return (
//     <div className='w-full min-w-[200px] max-w-[200px] bg-white hover:shadow-lg drop-shadow-lg py-5 px-4 cursor-pointer flex flex-col'>
//         {
//             image ? 
//             <>
//             <Link to={`/menu/${id}`} onClick={()=>window.scrollTo({top:0, behavior: "smooth"})}>
//                 <div className='h-28 flex flex-col justify-center items-center'>
//                     <img src={image} alt='images' className='h-full' />
//                 </div>
//                     <h3 className='font-semibold text-slate-600 capitalize text-lg mt-4 text-center whitespace-nowrap overflow-hidden'>
//                         {name}
//                     </h3>
//                     <p className='text-slate-500 font-medium text-center'>{category}</p> 
//                     <p className= 'font-bold text-center'>
//                         <span className='text-red-500'>₹</span>
//                         <span>{price}</span>
//                     </p>
//                 </Link> 
//                 <button className='bg-yellow-500 py-1 mt-2 rounded hover:bg-yellow-600 w-full' onClick={handleAddCartProduct}>Add Cart</button>

//             </>

//             :

//             (
//             <div className='min-h-[150px] flex justify-center items-center'>
//                 <p>{loading}</p>
//             </div>
//         )}  

//     </div>

//   );
// };

// export default CardFeature


import React from 'react';
import { Link } from 'react-router';
import { useDispatch } from 'react-redux';
import { addCartItem } from '../redux/productSlice';
import { BsCartPlusFill, BsLightningChargeFill } from 'react-icons/bs';

// ── Skeleton ──────────────────────────────────────────────────────────────────
function CardSkeleton() {
  return (
    <div
      className="flex-shrink-0 rounded-2xl overflow-hidden"
      style={{
        width: 200,
        minWidth: 200,
        background: 'var(--bg-raised)',
        border: '1px solid var(--glass-border)',
      }}
    >
      {/* Image placeholder */}
      <div className="skeleton" style={{ height: 164, margin: 0, borderRadius: 0 }} />
      <div className="p-4 space-y-3">
        <div className="skeleton h-3 w-16 rounded" />
        <div className="skeleton h-4 w-full rounded" />
        <div className="skeleton h-4 w-2/3 rounded" />
        <div className="skeleton h-8 w-full rounded-xl mt-4" />
      </div>
    </div>
  );
}

// ── Main card ─────────────────────────────────────────────────────────────────
export default function CardFeature({ image, name, category, price, loading, id }) {
  const dispatch = useDispatch();

  if (!image) return <CardSkeleton />;

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(addCartItem({ _id: id, name, price, category, image }));
  };

  return (
    <div
      className="
        flex-shrink-0 glass-card card-electric rounded-2xl overflow-hidden
        flex flex-col group
      "
      style={{
        width: 200,
        minWidth: 200,
        background: 'var(--bg-raised)',
        border: '1px solid var(--glass-border)',
      }}
    >
      {/* Image zone */}
      <Link
        to={`/menu/${id}`}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="block"
        tabIndex="-1"
      >
        <div
          className="relative overflow-hidden flex items-center justify-center"
          style={{ height: 164, background: 'var(--bg-surface)' }}
        >
          {/* Radial glow on hover */}
          <div
            className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
            style={{
              background: 'radial-gradient(circle at 50% 60%, rgba(99,102,241,0.12) 0%, transparent 70%)',
            }}
          />
          <img
            src={image}
            alt={name}
            className="
              relative z-10 object-contain transition-transform duration-500
              group-hover:scale-110
            "
            style={{ maxHeight: 140, maxWidth: 160 }}
          />
        </div>
      </Link>

      {/* Info */}
      <div className="flex flex-col flex-1 p-4 pt-3 gap-1">
        <Link
          to={`/menu/${id}`}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <span className="badge" style={{ fontSize: '0.58rem' }}>{category}</span>
          <h3
            className="
              mt-2 text-sm font-semibold leading-tight capitalize
              line-clamp-2 group-hover:text-gradient transition-all duration-300
            "
            style={{ color: 'var(--text-primary)', fontFamily: 'var(--font-body)', minHeight: 40 }}
          >
            {name}
          </h3>
          <p
            className="mt-1 font-display text-base font-bold"
            style={{ color: 'var(--text-primary)' }}
          >
            <span style={{ color: 'var(--coral)' }}>₹</span>
            <span className="text-gradient">{price}</span>
          </p>
        </Link>

        <button
          onClick={handleAdd}
          className="
            btn-primary mt-auto w-full py-2 rounded-xl
            flex items-center justify-center gap-2
          "
        >
          <BsCartPlusFill className="text-sm" />
          Add to Cart
        </button>
      </div>
    </div>
  );
}
